import { LANGUAGE_TAG_ENUM } from '../../lib/lang/value';
import { SELECT_INTER } from '../event-create/constant';

export const MODULE_NAME = 'POPUP_ITEM_UPDATE_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export enum FORM_VALUE_ENUM {
  BODY = 'body',
  IMG_URL = 'imgUrl',
  LINK_URL = 'linkUrl',
  DEADLINE = 'deadline',
  STATUS = 'status',
  LANG = 'lang',
}

export type FORM_VALUE_TYPE = `${FORM_VALUE_ENUM}`;

export interface FORM_VALUE_INTER {
  [FORM_VALUE_ENUM.BODY]: string;
  [FORM_VALUE_ENUM.DEADLINE]: string;
  [FORM_VALUE_ENUM.IMG_URL]: string;
  [FORM_VALUE_ENUM.LINK_URL]: string;
  [FORM_VALUE_ENUM.STATUS]: SELECT_INTER[];
  [FORM_VALUE_ENUM.LANG]: LANGUAGE_TAG_ENUM;
}

export const API = {
  UPDATE: {
    TYPE: 'PATCH',
    URL: (popupId?: string) => `popup/update/${popupId}`,
  },
};

export interface ACTION_ERROR_INTER {
  error: string;
  message: string;
  statusCode: string;
}
